import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { space, layout, color } from 'styled-system';

const Chip = styled.div`
  background: var(--linearGradientMixed);
  height: 28px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  padding: 4px 16px;
  color: white;
  ${color};
  ${space};
  ${layout};
`;

Chip.propTypes = {
  ...space.propTypes,
  ...layout.propTypes,
  ...color.propTypes,
};

export default Chip;
